module.exports = __webpack_public_path__ + "img/what-is-oah-enterprise-thumbnail-arrow.c98440a6.jpg";